import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import sistemaStore from "./sistema";
import usuarioStore from "./usuario";
import clientesStore from "./clientes";
import locaisStore from "./locais";
import pedidosStore from "./pedidos";
import baseStore from "./base";
import relatoriosStore from "./relatorios";
import insumosStore from "./insumos";
import formacaoCargaStore from "./formacaoCarga";

export default new Vuex.Store({
  modules: {
    sistema: sistemaStore,
    usuario: usuarioStore,
    clientes: clientesStore,
    locais: locaisStore,
    pedidos: pedidosStore,
    base: baseStore,
    relatorios: relatoriosStore,
    insumos: insumosStore,
    formacaoCarga: formacaoCargaStore,
  },
});
